import React from "react";
import { useState } from "@vrf/fr-vrf-core-react";
import {
  LinkComponentProjectDialogContext,
  LinkComponentProjectDialogInitialState,
} from "./";

export const LinkComponentProjectDialogStateProvider = ({ children }: any) => {
  const [pageState, setPageState] = useState(
    LinkComponentProjectDialogInitialState,
  );
  const context = {
    pageState: pageState,
    setPageState: setPageState,
  };
  return (
    <LinkComponentProjectDialogContext.Provider value={context}>
      {children}
    </LinkComponentProjectDialogContext.Provider>
  );
};
